import React, { memo } from 'react';
import FormControlSelect from './index';

var FormControlSelectSkeleton = function FormControlSelectSkeleton(props) {
  return /*#__PURE__*/React.createElement(FormControlSelect, Object.assign({
    disabled: true
  }, props));
};

export default /*#__PURE__*/memo(FormControlSelectSkeleton);